import { storageService } from '@/services'
import { makeUser } from '@/util/apiHelper'

export const state = () => ({
  errorsLogin: {},
  restorePasswordRequest: {},
  restorePasswordConfirm: {},
  restorePasswordForm: {},
  showPromoPopup: false,
  resultPasswordRequest: false,
  normalRestorePasswordResponse: null,
  resultPasswordChange: false,
  isSuccessPasswordChange: false,
})

export const mutations = {
  set_loginErrors(state, errorsLogin) {
    state.errorsLogin = errorsLogin
  },
  set_restorePasswordRequest(state, restorePasswordRequest) {
    state.restorePasswordRequest = restorePasswordRequest
  },
  set_normalPasswordResponse(state, res) {
    state.normalRestorePasswordResponse = res
  },
  set_restorePasswordConfirm(state, restorePasswordConfirm) {
    state.restorePasswordConfirm = restorePasswordConfirm
  },
  set_restorePasswordForm(state, { restorePasswordForm }) {
    state.restorePasswordForm = restorePasswordForm
  },
  set_showPromoPopup(state, isShowPromoPopup) {
    state.showPromoPopup = isShowPromoPopup
  },
  set_hidePromoPopup(state) {
    state.showPromoPopup = false
  },
  set_resultPasswordRequest(state, data) {
    state.resultPasswordRequest = data
  },
  set_resultPasswordChange(state, data) {
    state.resultPasswordChange = data
  },
  set_isSuccessPasswordChange(state, data) {
    state.isSuccessPasswordChange = data
  },
}

export const actions = {
  act_login({ commit, dispatch }, { password, type, email = null, phone_code = null, phone = null }) {
    return new Promise((resolve, reject) => {
      commit('user/auth_request', null, { root: true })
      const loginRequest = this.$api.auth.login({ password, type, email, phone_code, phone })
      const loginPromise = loginRequest.then((resp) => {
        if (!resp.data.status) {
          const errorsLogin = resp.data.errors
          commit('set_loginErrors', errorsLogin)
          reject(resp.data)
          return Promise.reject(resp.data)
        }
        storageService.removeUtm()
        const token = resp.data.user.token
        const showPromoPopup = resp.data.showPromoPopup
        commit('set_showPromoPopup', showPromoPopup)
        storageService.saveToken(token)
        // this.$api.$commonToken = token

        const user = resp.data.user
        commit('user/auth_success', { token, user }, { root: true })
        return resp
      })
      loginPromise.then((loginResponce) => {
        // const token = this.$api.$token
        const profileRequest = this.$api.profile.profileInfo()
        profileRequest.then((profileResponce) => {
          const userData = makeUser(profileResponce.data.user)

          commit('user/SET_PROFILE_INFO', { user: userData, userDataStatus: profileResponce.data.status, abTests: profileResponce.data.ab_tests }, { root: true })
          dispatch('promotions/fetch_newPromotions', null, { root: true })
          resolve(profileResponce.data.user)

          try {
            window.dispatchEvent(new CustomEvent('userLogin'))
          }
          catch (e) { }

          return profileRequest
        })
      })
        .catch((error) => {
          commit('user/auth_error', error, { root: true })
          storageService.removeToken()
          reject(error)
          return Promise.reject(error)
        })

      return loginPromise
    })
  },

  hide_promoPopup({ commit }) {
    commit('set_hidePromoPopup')
  },

  async restore_passwordRequest({ commit }, { type, email = null, phone_code = null, phone = null, recaptchaToken = null }) {
    try {
      const res = await this.$api.auth.restorePassReq({ type, email, phone_code, phone, recaptchaToken })
      commit('set_restorePasswordRequest', { restorePasswordRequest: res.data })
      commit('set_normalPasswordResponse', res.data)
      if (res.data.status) {
        commit('set_resultPasswordRequest', true)
      }
      return res.data
    }
    catch (e) { }
  },

  async restore_passwordConfirm({ commit }, { restore_token, recaptchaToken = null }) {
    try {
      const res = await this.$api.auth.restorePassConfirm({ restore_token, recaptchaToken })
      if (res.data.user && res.data.user.token) {
        const token = res.data.user.token
        storageService.saveToken(token)
      }
      commit('set_restorePasswordConfirm', { restorePasswordConfirm: res.data })
      return res.data
    }
    catch (e) { }
  },
  async restore_passwordForm({ commit }, { password, password2 }) {
    try {
      const res = await this.$api.auth.restorePassForm({ password, password2 })
      commit('set_restorePasswordForm', { restorePasswordForm: res.data })
      return res.data
    }
    catch (e) { }
  },
  act_resultPasswordRequest({ commit }, bool) {
    commit('set_resultPasswordRequest', bool)
  },
  act_resultPasswordChange({ commit }, bool) {
    commit('set_resultPasswordChange', bool)
  },
  act_isSuccessPasswordChange({ commit }, bool) {
    commit('set_isSuccessPasswordChange', bool)
  },
}

export const getters = {
  get_loginErrors: state => state.errorsLogin,
  get_restorePasswordRequest: state => state.restorePasswordRequest,
  get_restorePasswordConfirm: state => state.restorePasswordConfirm,
  get_restorePasswordForm: state => state.restorePasswordForm,
  get_showPromoPopup: state => state.showPromoPopup,
  get_resultPasswordRequest: state => state.resultPasswordRequest,
  get_resultPasswordChange: state => state.resultPasswordChange,
  get_isSuccessPasswordChange: state => state.isSuccessPasswordChange,
  get_normalPasswordResponse: state => state.normalRestorePasswordResponse,
}
